import { useEffect } from "react";

/**
 * Loads AccessWidget on the marketing site.
 * Controlled by env vars so we can change siteKey without code changes.
 *
 * Env:
 * - REACT_APP_MARKETING_SITE_KEY: the siteKey to use
 * - REACT_APP_WIDGET_SERVER_URL: optional, defaults to REACT_APP_SERVER_URL, defaults to http://localhost:5000
 */
export default function MarketingWidgetLoader() {
  useEffect(() => {
    const runtime = (window.__AW_RUNTIME_CONFIG__ || {});
    const siteKey = String(runtime.marketingSiteKey || process.env.REACT_APP_MARKETING_SITE_KEY || "").trim();
    if (!siteKey) return;

    const serverUrl = String(
      runtime.widgetServerUrl ||
        process.env.REACT_APP_WIDGET_SERVER_URL ||
        process.env.REACT_APP_SERVER_URL ||
        "http://localhost:5000"
    ).replace(/\/$/, "");

    // Provide explicit base URL for embed.js (so config fetch goes to the same server)
    window.AccessWidget = window.AccessWidget || {};
    window.AccessWidget.serverUrl = serverUrl;

    const inject = () => {
      if (document.getElementById("aw-embed")) return;
      const s = document.createElement("script");
      s.id = "aw-embed";
      s.src = `${serverUrl}/widget/embed.js`;
      s.async = true;
      s.setAttribute("data-site-key", siteKey);
      s.setAttribute("data-aw-loader", "v2");
      document.body.appendChild(s);
    };

    // Inject only after "load" so the widget never delays the page.
    if (document.readyState === "complete") {
      inject();
      return undefined;
    }
    window.addEventListener("load", inject);
    return () => window.removeEventListener("load", inject);
  }, []);

  return null;
}


